import { getData, postData } from "../apiClient";

const API_URL = `duty-attendance`;

// --- ATTENDANCE API ---
export const getAttendanceStats = async (date, rosterId = null) => {
  try {
    const params = rosterId ? { date, roster_id: rosterId } : { date };
    const queryParams = new URLSearchParams(params).toString();
    const response = await getData(`${API_URL}/stats?${queryParams}`);
    return {
      success: true,
      data: response?.data || response,
    };
  } catch (error) {
    console.error("Get Attendance Stats API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data?.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getEmployeesByRoster = async (date, rosterId) => {
  try {
    const params = { date, roster_id: rosterId };
    const queryParams = new URLSearchParams(params).toString();
    const response = await getData(
      `${API_URL}/employees-by-roster?${queryParams}`,
    );
    return {
      success: true,
      data: response?.data || response,
    };
  } catch (error) {
    console.error("Get Employees by Roster API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data?.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getAllRostersForDashboard = async () => {
  try {
    const response = await getData(`${API_URL}/rosters`);
    return {
      success: true,
      data: response?.data || response,
    };
  } catch (error) {
    console.error("Get All Rosters API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data?.error : error.message,
        status: error.status,
      },
    };
  }
};
